import styled from '@emotion/styled'

const FiltersContainer = styled.div`
  display: flex;
  margin-bottom: 12px;
  min-height: 38px;
  gap: 8px;
`

export default FiltersContainer
